import { render, staticRenderFns } from "./SummerSaleBadge.vue?vue&type=template&id=bd8228ce&scoped=true"
import script from "./SummerSaleBadge.vue?vue&type=script&lang=js"
export * from "./SummerSaleBadge.vue?vue&type=script&lang=js"
import style0 from "./SummerSaleBadge.vue?vue&type=style&index=0&id=bd8228ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8228ce",
  null
  
)

export default component.exports